// @vendor
const PropTypes = require('prop-types');
const React = require('react');

// @utilities
const { FormattedText } = require('core/i18n').i18n;

function buildPGSectionRentability(value) {
    return (
        <FormattedText
            className="ra-expected-profitability__legend-info ra-expected-profitability__footer-legend-info"
            value={value}
        />
    );
}

const RAExpectedProfitabilityFooter = ({ pgSection }) => {
    const colSize = pgSection ? 'col-md-12' : 'col-md-6';
    const pgSectionText = (
        <div className={colSize}>
            <FormattedText
                className="ra-expected-profitability__text"
                value="rentabilityGraph-text"
            />
        </div>
    );
    const pgSectionTextNoPg = !pgSection ? pgSectionText : null;
    const pgSectionTextPg = pgSection ? pgSectionText : null;
    const pgSectionRentabilityLast = !pgSection
        ? buildPGSectionRentability('rentabilityGraph-legendInfoLast')
        : null;
    const pgSectionRentabilityMiddle = !pgSection
        ? buildPGSectionRentability('rentabilityGraph-legendInfoMiddle')
        : null;
    const pgSectionRentabilityFirst = !pgSection
        ? buildPGSectionRentability('rentabilityGraph-legendInfoFirst')
        : null;
    return (
        <div className="ra-expected-profitability__footer">
            <div className="row">
                {pgSectionTextNoPg}
                <div className={colSize}>
                    <div className="ra-expected-profitability__legends">
                        <div className="row no-gutter">
                            <div className="col-md-4">
                                <div className="ra-expected-profitability__legend ra-expected-profitability--light-blue">
                                    <div className="ra-expected-profitability__legend-text">
                                        <div>
                                            <span className="ra-expected-profitability__circle" />
                                            <FormattedText value="rentabilityGraph-maximumLabel" />
                                        </div>
                                        {pgSectionRentabilityLast}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="ra-expected-profitability__legend ra-expected-profitability--white">
                                    <div className="ra-expected-profitability__legend-text">
                                        <div>
                                            <span className="ra-expected-profitability__circle" />
                                            <FormattedText value="rentabilityGraph-expectedLabel" />
                                        </div>
                                        {pgSectionRentabilityMiddle}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="ra-expected-profitability__legend ra-expected-profitability--grey">
                                    <div className="ra-expected-profitability__legend-text">
                                        <div>
                                            <span className="ra-expected-profitability__circle" />
                                            <FormattedText value="rentabilityGraph-minimumLabel" />
                                        </div>
                                        {pgSectionRentabilityFirst}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {pgSectionTextPg}
            </div>
        </div>
    );
};

RAExpectedProfitabilityFooter.propTypes = {
    pgSection: PropTypes.bool,
};

module.exports = RAExpectedProfitabilityFooter;
